import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube, Wrench, PhoneCall } from "lucide-react";
import { PHONE_NUMBER, PHONE_TEL, SALES_PHONE, SALES_TEL, SERVICE_PHONE, SERVICE_TEL, EMAIL, ADDRESS, INSTAGRAM } from "../lib/api";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-zinc-900 pt-20 pb-10 relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-600 to-transparent" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="lg:col-span-2">
          <Link to="/" className="flex items-center">
            <img src="/gensan-logo-full.png" alt="Gensan Motors" className="h-20 w-auto object-contain" />
          </Link>
          <p className="mt-6 text-zinc-400 text-sm leading-relaxed max-w-md">
            Sıfır ve ikinci el motosiklet galerimizde hayalinizdeki motoru keşfedin. Geniş stok, güvenilir alışveriş ve uzman ekibimizle yanınızdayız.
          </p>
          <div className="mt-8 flex gap-3">
            <a
              href={`https://instagram.com/${INSTAGRAM}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="w-11 h-11 border border-zinc-800 hover:border-orange-600 hover:bg-orange-600 flex items-center justify-center text-zinc-300 hover:text-white transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="w-11 h-11 border border-zinc-800 hover:border-orange-600 hover:bg-orange-600 flex items-center justify-center text-zinc-300 hover:text-white transition-colors"
              aria-label="Facebook"
            >
              <Facebook size={18} />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube"
              className="w-11 h-11 border border-zinc-800 hover:border-orange-600 hover:bg-orange-600 flex items-center justify-center text-zinc-300 hover:text-white transition-colors"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </a>
          </div>
        </div>

        {/* Sayfalar */}
        <div>
          <h4 className="font-impact text-lg uppercase tracking-widest text-white mb-6">
            Sayfalar
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="text-zinc-400 hover:text-orange-500 transition-colors">Ana Sayfa</Link></li>
            <li><Link to="/sifir-motorlar" className="text-zinc-400 hover:text-orange-500 transition-colors">Sıfır Motorlar</Link></li>
            <li><Link to="/ikinci-el-motorlar" className="text-zinc-400 hover:text-orange-500 transition-colors">İkinci El Motorlar</Link></li>
            <li><Link to="/hakkimizda" className="text-zinc-400 hover:text-orange-500 transition-colors">Hakkımızda</Link></li>
            <li><Link to="/iletisim" className="text-zinc-400 hover:text-orange-500 transition-colors">İletişim</Link></li>
          </ul>
        </div>

        {/* İletişim */}
        <div>
          <h4 className="font-impact text-lg uppercase tracking-widest text-white mb-6">
            İletişim
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-orange-500 mt-1 shrink-0" />
              <a href={`tel:${SALES_TEL}`} data-testid="footer-sales-phone" className="text-zinc-300 hover:text-orange-500 transition-colors">
                <span className="block text-[10px] uppercase tracking-widest text-zinc-500">Satış</span>
                {SALES_PHONE}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Wrench size={16} className="text-orange-500 mt-1 shrink-0" />
              <a href={`tel:${SERVICE_TEL}`} data-testid="footer-service-phone" className="text-zinc-300 hover:text-orange-500 transition-colors">
                <span className="block text-[10px] uppercase tracking-widest text-zinc-500">Servis</span>
                {SERVICE_PHONE}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <PhoneCall size={16} className="text-orange-500 mt-1 shrink-0" />
              <a href={`tel:${PHONE_TEL}`} data-testid="footer-landline-phone" className="text-zinc-300 hover:text-orange-500 transition-colors">
                <span className="block text-[10px] uppercase tracking-widest text-zinc-500">Sabit Hat</span>
                {PHONE_NUMBER}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-orange-500 mt-1 shrink-0" />
              <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="text-zinc-300 hover:text-orange-500 transition-colors break-all">
                {EMAIL}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-orange-500 mt-1 shrink-0" />
              <span className="text-zinc-400">{ADDRESS}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-16 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-zinc-500 uppercase tracking-widest">
          © {new Date().getFullYear()} Gensan Motors — Tüm hakları saklıdır.
        </p>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">
          Ride Hard. Live Free.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
